<app-menu></app-menu>
<div id="loginContainer" class="backgroundSand">
  <div class="loginImg">
    <img
      src="../../../assets/images/login/LogoTritonText1.png"
      alt="Logo de triton"
    />
  </div>
  <div class="formContainer">
    <form class="loginForm" #f="ngForm" (ngSubmit)="onLogin()" novalidate>
      <div class="usuarioContainer">
        <div class="label usuarioLabel inputLabel">
          <strong>Usuario</strong>
        </div>
        <div class="inputForm usuarioInputForm inputText">
          <input type="text" [(ngModel)]="nombreUsuario" name="user" required />
        </div>
      </div>
      <div class="passwordContainer">
        <div class="label passwordLabel inputLabel">
          <strong>Contraseña</strong>
        </div>
        <div class="inputForm passwordInputForm inputText">
          <input
            type="{{ showPassword ? 'password' : 'text' }}"
            [(ngModel)]="password"
            name="password"
            noterequired
          />
          <div (click)="changeView()" style="cursor: pointer">
            <span *ngIf="showPassword" class="icon"
              ><i class="fas fa-eye"></i>
            </span>
            <span *ngIf="!showPassword" class="icon">
              <i class="fas fa-eye-slash"></i
            ></span>
            <!---->
          </div>
        </div>
      </div>
      <div class="actionContainer">
        <!--<div class="rememberContainer">
          <input
            type="checkbox"
            [checked]="checked"
            (change)="checked = !checked"
          />
          <label>Recuerdame </label>
        </div>-->

        <div class="accederButton">
          <button class="submitButton">
            <em class="fas fa-sign-in-alt"></em>
          </button>
        </div>
        <a routerLink="/solicitud-recuperar-contrasena">Recuperar contraseña</a>
      </div>
    </form>
  </div>

  <div class="extraContainer">
    <div class="infoText">
      <u>Información</u>
      <div class="col-12">
        Teléfono de contacto: 93 708 77 00 (8:00 a 16:30h)
      </div>
      <div class="col-12">Consulta certificados:</div>
      <div class="col-11 margin">
        <p>homologaciones.seat@seat.es</p>
        <p>homologaciones.vw@seat.es</p>
        <p>homologaciones.audi@seat.es</p>
        <p>homologaciones.skoda@seat.es</p>
        <p>homologaciones.lcv@seat.es</p>
      </div>
      <div class="col-12">Consulta CoC VGED:</div>
      <div class="col-11 margin">
        <p>consultacocvged@volkswagengroup.es</p>
      </div>
      <div class="col-12">Incidencias:</div>
      <div class="col-11 margin">
        <p>triton@seat.es</p>
      </div>
    </div>
    <div class="avisosText" style="color: #f96c64">
      <p *ngIf="initMessage">
        <u>Aviso</u><br /><br /><span>{{ initMessage }}</span>
      </p>
    </div>
  </div>

  <div class="brands backgroundWhite">
    <div class="brandLogo">
      <img
        class="seat"
        src="../../../assets/images/login/seat.png"
        alt="Logo de Seat"
      />
    </div>
    <div class="brandLogo">
      <img
        class="cupra"
        src="../../../assets/images/login/cupra.png"
        alt="Logo de Cupra"
      />
    </div>
    <div class="brandLogo">
      <img
        class="vw"
        src="../../../assets/images/login/ww1.png"
        alt="Logo de VW"
      />
    </div>
    <div class="brandLogo">
      <img
        class="audi"
        src="../../../assets/images/login/audi.png"
        alt="Logo de Audi"
      />
    </div>
    <div class="brandLogo">
      <img
        class="skoda"
        src="../../../assets/images/login/skoda.png"
        alt="Logo de Skoda"
      />
    </div>
    <div class="brandLogo">
      <img
        src="../../../assets/images/login/ww2.png"
        alt="Logo grupo VW"
        class="comerciales"
      />
    </div>
  </div>
</div>
